import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LeadTimeRule } from '../../shared/models/LeadTimeRule';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { EditLeadTimeRuleComponent } from '../edit-lead-time-rule/edit-lead-time-rule.component';
import { faPenToSquare, faX } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-lead-time-rules',
  templateUrl: './lead-time-rules.component.html',
  styleUrl: './lead-time-rules.component.css'
})
export class LeadTimeRulesComponent implements OnInit{
  Rules: LeadTimeRule[];
  CurUser: User;
  TestConfigString: string;
  TestConfigResults: string;
  faEdit = faPenToSquare;
  faX = faX;
  public constructor(private http: HttpService, private global: GlobalService, private router: Router, public matDialog: MatDialog) {

  }

  ngOnInit() {
    this.TestConfigString = "";
    this.TestConfigResults = "";
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
    this.LoadRules();
  }

  LoadRules() {
    this.http.GetLeadTimeRules().then(x => {
      if (x.StatusCode == "200") {
        this.Rules = <LeadTimeRule[]>x.Content;
      }
    });
  }

  CreateNewRule() {
    var dialogConfig = {
      width: '600px',
      height: '300px'
    };
    var currentDialog = this.matDialog.open(EditLeadTimeRuleComponent, dialogConfig);


    currentDialog.componentInstance.CurrentRule = new LeadTimeRule();
    currentDialog.componentInstance.IsCreate = true;

    currentDialog.componentInstance.SaveRuleEmitter.subscribe(item => {
      item.CreatedBy = this.CurUser.UserId.toString();
      item.UpdatedBy = this.CurUser.UserId.toString();
      this.http.SaveLeadTimeRule(item).then(x => {
        this.LoadRules();
        currentDialog.close();
      });
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  Option_Change(ev: any, rule: LeadTimeRule) {
    if (ev.value == "edit") {
      
    } else if (ev.value == "delete") {
     
    }
  }

  EditRule(rule: LeadTimeRule) {
    var dialogConfig = {
      width: '600px',
      height: '300px'
    };
    var currentDialog = this.matDialog.open(EditLeadTimeRuleComponent, dialogConfig);


    currentDialog.componentInstance.CurrentRule = rule;
    currentDialog.componentInstance.IsCreate = false;

    currentDialog.componentInstance.SaveRuleEmitter.subscribe(item => {
      item.UpdatedBy = this.CurUser.UserId.toString();
      this.http.SaveLeadTimeRule(item).then(x => {
        currentDialog.close();
        this.LoadRules();
      });
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  DeleteRule(rule: LeadTimeRule) {
    rule.Deleted = true;
    rule.UpdatedBy = this.CurUser.UserId.toString();
    this.http.SaveLeadTimeRule(rule).then(x => {
      this.LoadRules();
    });
  }

  TestConfigStringLeadTime() {
    this.TestConfigString = this.TestConfigString.trim();
    if (this.TestConfigString != "") {
      this.http.TestConfigString(this.GetItemCode(this.TestConfigString), this.TestConfigString).then(x => {
        if (x.StatusCode == "200") {
          this.TestConfigResults = x.Content;
        }
      });
    }
  }

  public GetItemCode(ConfigString: string): string {
    var itemCode = "";
    if (ConfigString != "") {
      var first2 = ConfigString.substring(0, 2).toUpperCase();
      var first3 = ConfigString.substring(0, 3).toUpperCase();
      var first4 = ConfigString.substring(0, 4).toUpperCase();
      switch (first3) {
        case "ACS":
        case "B3B":
        case "B3S":
        case "B3W":
        case "BC2":
        case "BC3":
        case "BC4":
        case "BCS":
        case "ERD":
        case "GSA":
        case "ICR":
        case "IMX":
        case "MMC":
        case "MMK":
        case "MXB":
        case "MXE":
        case "MXP":
        case "NDB":
        case "NGS":
        case "NMB":
        case "NNR":
        case "NPR":
        case "NRE":
        case "NSB":
        case "PB2":
        case "RLS":
        case "RSA":
        case "RSH":
        case "RSX":
        case "RTB":
        case "SLS":
        case "SVC":
        case "TBD":
        case "TKB":
        case "TKS":
        case "TRA":
        case "TRS":
        case "CSM":
          itemCode = first3;
          break;
        case "IMA":
          if (first4 != "IMAS") {
            itemCode = first3;
          }
          else {
            itemCode = first4;
          }
          break;
        default:
          break;
      }
      if (itemCode == "") {
        switch (first2) {
          case "CA":
          case "CC":
          case "GD":
          case "IM":
          case "LS":
          case "MG":
          case "PB":
          case "RB":
          case "RK":
          case "SW":
          case "WS":
            itemCode = first2;
            break;
        }
      }
      
    }
    return itemCode;
  }

}
